import axios from "axios";
import store from "@/store";
import router from '@/router';

const baseURL = process.env.VUE_APP_API_URL ?? "http://localhost:8086/api/v1";

let httpClient = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(
  async config => {
    config.headers["auth_token"] = `${store.state.authToken}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(response => response,
  error => {
    if (error?.response?.status === 401) {
      store.dispatch('logout');
      router.replace('/login');
    }
    return Promise.reject(error);
  }
);

export default httpClient;
